import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Modal,
  MultiSelect,
  Select,
  Textarea,
  Textfield,
} from "../../../../../../components/core";
import { Button as PrimereactButton } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { handleAddChange } from "../../../../../../features/partner-types/partner-types-table-slice";
import useSidebarStore from "../../../../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";
import { CREATE_PARTNER_TYPE } from "../../../../../../constants/graphql/partner-types-query";
import { useMutation } from "@apollo/client";
import { Strings } from "../../../../../../constants/strings";
import { Divider } from "primereact/divider";
const AddPartnerTypeDialog = ({
  openAddDialog,
  setOpenAddDialog,
  // onChange,
  index = 0,
  cancelAddPartnerType,
  // openCancelModal,
  // setOpenCancelModal,
  setChangesMade,
  changesMade,
}) => {
  // LS
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;

  // utils
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addedData = useSelector((state) => state.partnerTypesTable.addedData);

  // graphql calls
  const [addPartnerTypeMutation] = useMutation(CREATE_PARTNER_TYPE);

  // constant variable
  const partnerCategoryList = [
    { value: 0, name: "Courier" },
    { value: 1, name: "Seller" },
  ];
  const lockerTypes = [
    { value: 1, label: "Parcel" },
    { value: 2, label: "Fridge" },
  ];

  // local variables
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);

  // validation dialog
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
    actions: "",
  });

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  // memos
  // Convert stored numeric IDs back to objects for MultiSelect
  const selectedLockerTypes = useMemo(() => {
    if (!addedData[index]?.lockerTypes) return [];

    return addedData[index].lockerTypes.map(
      (typeId) =>
        // Find the matching object from lockerTypes array
        lockerTypes.find((type) => type.value === typeId) || {
          value: typeId,
          label: `Type ${typeId}`,
        }
    );
  }, [addedData, index, lockerTypes]);

  const handleAddChanged = (event, index) => {
    const { name, value } = event.target;
    console.log({ name, value });
    setChangesMade(true);
    dispatch(
      handleAddChange({ data: { target: { name, value } }, index: index })
    );
  };

  const validateFields = (index = 0) => {
    // Check if addedData exists and has entries at the specified index
    if (!addedData || !addedData[index]) {
      console.error("No data at specified index to validate");
      return false;
    }

    console.log({ INSIDE_VALIDATE: addedData[index] });

    // Define required fields
    const requiredFields = {
      partnerType: "Partner Type",
      partnerCategoryNo: "Partner Category",
      monthlyFee: "Monthly Fee",
      description: "Description",
    };

    // Check for lockerTypes specifically since it's an array
    if (
      !addedData[index].lockerTypes ||
      addedData[index].lockerTypes.length === 0
    ) {
      showValidationError(
        "Locker Types",
        "At least one locker type must be selected."
      );
      return false;
    }

    // Check all other required fields
    for (const [field, label] of Object.entries(requiredFields)) {
      if (!addedData[index][field] && addedData[index][field] !== 0) {
        showValidationError(label, `${label} is required.`);
        return false;
      }
    }

    // Additional validation for specific fields
    if (
      addedData[index].monthlyFee &&
      isNaN(parseFloat(addedData[index].monthlyFee))
    ) {
      showValidationError("Monthly Fee", "Monthly Fee must be a valid number.");
      return false;
    }

    // All validations passed
    setSaveDialogOpen(true);

    // Helper function to show the validation error modal
    function showValidationError(fieldName, message) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: `Missing ${fieldName}`,
        message: message,
        open: true,
        actions: (
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => {
                setValidation((prev) => ({
                  ...prev,
                  open: false,
                }));
              }}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    }
  };

  const addPartnerType = () => {
    addPartnerTypeMutation({
      variables: {
        operatorId: operatorId,
        partnerType: addedData[index].partnerType,
        partnerCategoryNo: addedData[index].partnerCategoryNo,
        lockerTypes: addedData[index].lockerTypes,
        description: addedData[index].description,
        monthlyFee: addedData[index].monthlyFee,
      },
    })
      .then((data) => {
        if (data) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_add,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));

                    window.location.reload();
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }
        // setUpdatingTable(false);
      })
      .catch((e) => {
        console.log({ ERROR: e });
        if (e.message.includes(`duplicate key value`)) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title_duplicate,
            message: "Partner Type already exists",
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                    setSaveDialogOpen(false);
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_add,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }
      });
  };

  console.log({ addedData, openAddDialog, changesMade });
  return (
    <>
      <Dialog
        visible={openAddDialog}
        onHide={() => {
          setOpenAddDialog(false);
        }}
        header="Add Partner Type"
        className="w-[480px] z-0"
        draggable={false}
        resizable={false}
        footer={
          // return(
          <div className="flex w-full items-center justify-center gap-2">
            <PrimereactButton
              className="border border-primary-primaryYellow bg-white text-black p-2 gap-2 font-normal"
              onClick={() => {
                setOpenCancelModal(true);
              }}
            >
              Cancel
            </PrimereactButton>
            <PrimereactButton
              className="bg-primary-primaryYellow p-2 gap-2 text-black font-semibold"
              onClick={() => validateFields()}
              disabled={!changesMade}
            >
              Add Partner Type
            </PrimereactButton>
          </div>
          // )
        }
      >
        <div className="flex gap-3 flex-col">
          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Partner Type:
            </div>
            <Textfield
              onChange={(e) => {
                handleAddChanged(e, index);
              }}
              name="partnerType"
              value={addedData[index]?.partnerType || ""}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Partner Category:
            </div>
            <Select
              defaultOption={{
                value: -1,
                name: "--- SELECT PARTNER CATEGORY ---",
              }}
              onChange={(e) => {
                handleAddChanged(e, index);
              }}
              items={partnerCategoryList}
              name={"partnerCategoryNo"}
              value={addedData[index]?.partnerCategoryNo}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Has Access To:
            </div>
            <MultiSelect
              items={lockerTypes}
              name={"lockerTypes"}
              onChange={(e) => {
                handleAddChanged(e, index);
              }}
              value={selectedLockerTypes}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Monthy Fee:
            </div>
            <Textfield
              onChange={(e) => {
                handleAddChanged(e, index);
              }}
              isNumberOnly={true}
              name="monthlyFee"
              value={addedData[index]?.monthlyFee}
            />
          </div>

          <div className="flex gap-2 flex-col">
            <div>
              <span className="text-red-500">* </span>Description:
            </div>
            <Textarea
              onChange={(e) => {
                handleAddChanged(e, index);
              }}
              name="description"
              value={addedData[index]?.description}
            />
          </div>

          {/* <div className="w-full px-4">
            <Divider className=" border border-gray-200"></Divider>
          </div> */}

          {/* <div className="flex gap-2 flex-col">
						<div>
							<span className="text-red-500">* </span>COD Allowance:
						</div>
						<Textfield
							onChange={(e) => {
								handleAddChanged(e, index);
							}}
							isNumberOnly={true}
							name="codAllowance"
							value={addedData[index]?.codAllowance}
						/>
					</div>

					<div className="flex gap-2 flex-col">
						<div>
							<span className="text-red-500">* </span>Disbursement Fee:
						</div>
						<Textfield
							onChange={(e) => {
								handleAddChanged(e, index);
							}}
							isNumberOnly={true}
							name="disbursementFee"
							value={addedData[index]?.disbursementFee}
						/>
					</div> */}
          {/* BUTTONS */}
        </div>
      </Dialog>

      {/* cancel dialog */}
      <Modal
        icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
        title="Cancel Changes"
        message="Are you sure you want to cancel all changes?"
        open={openCancelModal}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => {
                setOpenCancelModal(false);
                setActiveSubItem(activeSubItem);
                setPendingNavigation(null);
              }}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                // console.log("CLICK CLICK CLICK");
                setOpenAddDialog(false);
                setOpenCancelModal(false);
                setChangesMade(false);
                cancelAddPartnerType();
              }}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />

      <Modal
        icon={`${process.env.PUBLIC_URL}/assets/images/check.png`}
        title="Save Changes"
        message="Are you sure you want to save all changes?"
        open={saveDialogOpen}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setSaveDialogOpen(false)}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                addPartnerType();
              }}
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
};

export default AddPartnerTypeDialog;
